import { render, staticRenderFns } from "./OwnerSettlementProtocol.vue?vue&type=template&id=552a0811&scoped=true&lang=pug"
import script from "./OwnerSettlementProtocol.vue?vue&type=script&lang=js"
export * from "./OwnerSettlementProtocol.vue?vue&type=script&lang=js"
import style0 from "./OwnerSettlementProtocol.vue?vue&type=style&index=0&id=552a0811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a0811",
  null
  
)

export default component.exports